<section class="cta">
  <div class="container">
    <div class="row">
      <div class="cta-container">
        <h2>We are excited to listen from you</h2>
        <button routerLink="/contact" class="btn white-btn mt-40">Contact Us</button>
      </div>
    </div>
  </div>
</section>